import { getMasterGlobalTypeList } from 'services/axios/config'
import { getAllEmailTemplate, getEmailTemplate } from 'services/axios/emailTemplate'

export const actions = {
  FETCH_EMAIL_TEMPLATE: 'FETCH_EMAIL_TEMPLATE',
  FETCH_ALL_EMAIL_TEMPLATE: 'FETCH_ALL_EMAIL_TEMPLATE',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
  FETCH_TEMPLATE_TYPE: 'FETCH_TEMPLATE_TYPE',
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}

export const getEmailTemplateList = (value) => {
  return async (dispatch) => {
    const response = await getEmailTemplate(value)
    dispatch({ type: actions.FETCH_EMAIL_TEMPLATE, payload: response?.data })
  }
}

export const getAllEmailTemplateList = ({ skip, limit, search, templateType }) => {
  return async (dispatch) => {
    const response = await getAllEmailTemplate({ skip, limit, search, templateType })
    dispatch({ type: actions.FETCH_ALL_EMAIL_TEMPLATE, payload: response?.data?.data })
  }
}

export const fetchTemplateType = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('template_type')
    dispatch({ type: actions.FETCH_TEMPLATE_TYPE, payload: response?.data?.data })
  }
}
